<script setup lang="ts">
defineProps<{
  deposit: DefaultDepositInfoResponse;
}>();

const emit = defineEmits(['toggleModalInner']);

const { closeModal } = useLayoutStore();
const { updateWallet } = useWallet();

function closePaymentInfos() {
  emit('toggleModalInner');
}

const handdlePixPayed = () => {
  closeModal();
  updateWallet();
};
</script>

<template>
  <div :class="$style.depositPayment">
    <div
      v-if="deposit.payment_link"
      :class="$style.iframeBox"
    >
      <iframe
        frameborder="0"
        :src="deposit.payment_link"
      ></iframe>
      <BaseLoading
        class="!bg-auth-bg-primary !absolute !z-[1]"
        :show="true"
      />
    </div>

    <div
      v-else
      class="alert alert-error"
    >
      {{ $t('deposit.errors.processing_error') }}
    </div>

    <div class="text-center mt-3 mb-5">
      <div class="mt-3 flex items-center justify-center gap-3">
        <button
          :class="[$style.buttonsBottom, $style.back]"
          @click="closePaymentInfos()"
        >
          &#8592; {{ $t('deposit.worldline.go_back') }}
        </button>
        <button
          :class="[$style.buttonsBottom, $style.small]"
          variant="primary"
          @click="handdlePixPayed"
        >
          {{ $t('deposit.worldline.paid') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.depositPayment {
  .buttonsBottom {
    @apply inline-flex items-center justify-center gap-2;
    @apply text-auth-button-bg bg-auth-button-bg/10;
    @apply py-2 md:py-3 px-6 rounded w-full md:w-auto;
    &.small {
      @apply text-sm py-2 px-5 mt-2 -mb-2 text-success bg-success/10 w-auto;
    }
    &.back {
      @apply text-sm py-2 px-5 mt-2 -mb-2 text-primary bg-primary/10 w-auto;
    }
  }
}
.iframeBox {
  @apply w-full h-[480px] rounded overflow-hidden bg-texts/5 relative;
  iframe {
    @apply w-full h-full relative z-10;
  }
}
</style>
